import { inject, Component, ElementRef, HostBinding, HostListener, Injectable, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as d3 from "d3";
import { FilterService } from 'src/app/services/filter.service';
import { CurrencyPipe } from '@angular/common';
import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';
@Injectable({
  providedIn: 'root'
})
@Component({
    selector: 'app-small-bar-chart',
    templateUrl: './small-bar-chart.component.html',
    styleUrls: ['./small-bar-chart.component.scss'],
    standalone: false
})
export class SmallBarChartComponent implements OnInit, OnChanges {
  private readonly noDataNotifier = inject(NoDataNotifierService);
  @ViewChild('smallBarContainer', { static: true }) smallBarContainer!: ElementRef
  @ViewChild('BarContainer', { static: true }) BarContainer!: ElementRef
  @ViewChild('smallBarChart') smallBarChart!: ElementRef;
  @Input('data') data: any
  @Input('pageKey') pageKey: any
  @Input('item') item: any
  @Input('config') config: any
  @Input('headerConfig') headerConfig: any
  @Input('heading') heading: string = ''
  @Input('error_name') error_name: any
  @ViewChild('fs') fs!: ElementRef;
  isActive = false;
  iconList: any[] = []
  @HostBinding('class.is-fullscreen') isFullscreen = false;
  SmallBarChartData: any;
  props: any;
  divId: any = "SmallBarChartDiv";
  mytooltipData: any
  initiateChart: Boolean = false
  isTooltip: Boolean = false
  noData: Boolean = false
  dataTurn: any
  myType: any | undefined
  //sider Variables
private sliderSize = 300;
private handleRadius = 6;
private currentMin = 0;
private currentMax = 100;
private margins = {left:10,top:20}
private orientation = 'vertical';

 selectionBox: any;
  dragStartY: any;
  dragStartX: any;
  selectionBoxX: any;

  dragEndY: any;
  showPopup = false;
  selectedRange: { min: number; max: number } | null = null;
  isPercentStacked: boolean = true;

  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    this.cancelSelection();
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }

  constructor(private filterService: FilterService, private currency: CurrencyPipe) {
    this.filterService.filterQuery.subscribe((query: any) => {
      this.start()
    })
  }



  //loade Method
  isLoading = false;
  async stop(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }
  start() { this.isLoading = true; }

  ngOnInit(): void {
    this.start()
    this.iconList = this.item.config.icon ? this.item.config.icon : this.iconList 
    this.isPercentStacked = this.item.config?.["percent_bar"]?.value === 'true' ? true : false;
    this.divId = this.item.config.divId
    this.initiateCharts();

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'].currentValue != changes['data'].previousValue && this.initiateChart) {
      this.getSmallBarChartData();
    }
  }
  closeFullscreen(): void {
    this.isFullscreen = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    this.props.chartHeight = (this.item.config?.list_of_api?.api_key == 100609) ? 250 : 500
    this.isActive = false;
    
    setTimeout(() => {
      this.plotChart()
    }, 100);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    setTimeout(() => {
      this.plotChart()
    }, 100);
  }

  height: any = 0
  private showTooltip(myType: any, myData: any, myX: any, myY: any, chartWidth: any, chartHeight: any): void {
    this.myType = myType
    this.dataTurn = chartWidth - myX
    this.mytooltipData = myData
    this.height = 0
    this.dataTurn = 0
    this.height = chartHeight - myY
    this.dataTurn = chartWidth - myX

    if (myType == 'groupFullName') {
      d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('bottom', 'unset')
        .style('top', (myY+25) + 'px')

      if (this.dataTurn < 250) {
        d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
          .style('right', (this.dataTurn + 20) + 'px')
          .style('left', 'unset')
      }
      else if (this.dataTurn > 250) {
        d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
          .style('left', (myX + 25) + 'px')
          .style('right', 'unset')
      }

    }
    else {
      if (this.isFullscreen == true) {
        if (this.height < 200) {
          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            .style('bottom', (this.height) + 'px')
            .style('top', 'unset')

          if (this.mytooltipData.length == undefined) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('bottom', (this.height - 60) + 'px')
          }
          else if (this.mytooltipData.length > 0) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('bottom', (this.height - 60) + 'px')
          }
        }
        else if (this.height > 200) {

          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            // .style('top', (myY + 25) + 'px')
            .style('bottom', 'unset')

          if (this.mytooltipData.length == undefined) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('top', myY + 40 + 'px')
          }
          else if (this.mytooltipData.length > 0) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('top', myY + 30 + 'px')
          }
        }

        if (this.dataTurn < 250) {
          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            .style('right', (this.dataTurn + 20) + 'px')
            .style('left', 'unset')
        }
        else if (this.dataTurn > 250) {

          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            .style('left', (myX + 25) + 'px')
            .style('right', 'unset')
        }

        this.isTooltip = true
      }
      else {
        if (this.height < 200) {
          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            .style('bottom', (this.height) + 'px')
            .style('top', 'unset')

          if (this.mytooltipData.length == undefined) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('bottom', (this.height - 60) + 'px')
          } else if (this.mytooltipData.length > 0) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('bottom', (this.height - 60) + 'px')
          }
        }
        else if (this.height > 200) {

          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            // .style('top', (myY + 25) + 'px')
            .style('bottom', 'unset')

          if (this.mytooltipData.length == undefined) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('top', myY + 40 + 'px')
          } else if (this.mytooltipData.length > 0) {
            d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
              .style('top', myY + 30 + 'px')
          }
        }

        if (this.dataTurn < 250) {
          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            .style('right', (this.dataTurn + 20) + 'px')
            .style('left', 'unset')
        }
        else if (this.dataTurn > 250) {

          d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
            .style('visibility', 'visible')
            .style('position', 'absolute')
            .style('left', (myX + 25) + 'px')
            .style('right', 'unset')
        }

      }
    }
    this.isTooltip = true

  }

  private hideTooltip(myType: any): void {
    this.isTooltip = false
    // d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
    // .style('visibility', 'hidden');
  }

  //  d3 chart initial structure
  initiateCharts(): void {
    // only need to call this once on initialisation
    const myChart = this;
    const myClass = myChart.divId;

    const mySvg = d3.select(this.smallBarContainer.nativeElement)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr('width', '100%')
      .style('background-color', 'white');
      const defs = mySvg.append('defs');
      mySvg.append('g').attr('id', 'legendGroup' + myClass);
      defs.append('clipPath').attr('id', 'brushClip' + myClass)
        .append('rect').attr('id', 'brushClipRect' + myClass);

    mySvg.append("g").attr("class", "xAxis" + myClass);
    mySvg.append("g").attr("class", "yAxis" + myClass);
    mySvg.append('text').attr('id', 'xAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'yAxisLabel' + myClass);
    mySvg.append("g").attr("id", "chartGroup" + myClass);
    mySvg.append('g').attr('id', 'sliderGroup' + myClass).attr('class', 'slider' + myClass);
    this.initiateChart = true
  }
  // chart svg  plotChart rendering 
  plotChart(): void {
    const myChart:any = this;
    const myClass = myChart.divId;
    const mySvg: any = d3.select('#svg_' + myClass);
    // const container: any = d3.select(this.BarContainer.nativeElement);
    //   const clientWidth = container.node().getBoundingClientRect().width;
    var width: any = mySvg.node().getBoundingClientRect().width;
    const height = this.props.chartHeight;
    let margins = { left: 45, right: 12, top: 40, bottom: 48 };
      let barCount: any = new Set();
      myChart.SmallBarChartData.forEach((d: any) => {
        barCount.add(d[myChart.props.barVar]);
       
      })
    const barWidth = 60;
    const spacing = 10;
    const requiredWidth = barCount.size * (barWidth + spacing);
    //  const width = Math.max(clientWidth, requiredWidth, 500);
        
      // Bar Slider
      myChart.barMin = undefined;
      myChart.barMax = undefined;
      // Line Slider
      myChart.lineMin = undefined;
      myChart.lineMax = undefined;

    margins.top = !myChart.props.showLegend && myChart.props.stackVar === null ? 15 : 40;
    mySvg.attr("height", height);
    const chartHeight = height - margins.top - margins.bottom ;
    let yMax: any;
    let yScale: any = undefined;
    let yScaleHeight: any = undefined;
    const tickFormat: any = {"D": "%d %b %y", "W": "%d %b %y", "M": "%b %Y", "Q": "%b %Y", "Y": "%Y"};
    const timePeriod = myChart.props.period;
    const xTickFormat: any = d3.timeFormat(tickFormat[timePeriod]);
   
    myChart.SmallBarChartData.map((m: any) => m[myChart.props.yVar] = isNaN(m[myChart.props.yVar]) ? 0 : m[myChart.props.yVar])
    let barData: any = [];
    if (myChart.props.stackVar === null) {
      barData = d3.rollup(myChart.SmallBarChartData, (v: any) => d3.sum(v, (s: any) => s[myChart.props.yVar]), (d: any) => d[myChart.props.barVar])
      barData = Array.from(barData);
      barData = barData.map((m: any) => m = {
        name: m[0],
        value: m[1],
        start: 0,
        fill: myChart.props.barFill[myChart.props.yVar],
        borderRadius: 4
      });
      yMax = d3.max(barData, (d: any) => d.value+5);
      yMax = yMax > 5 ? yMax : 5;
      yScale = d3.scaleLinear().domain([0, yMax]).range([height - margins.top - margins.bottom, 0]);
      yScaleHeight = d3.scaleLinear().domain([0, yMax]).range([0, height - margins.top - margins.bottom]);
      barData.map((m: any) => m.height = yScaleHeight(m.value))
      barData.map((m: any) => m.borderRadius = 2);
      barData.map((m: any) => m.totalValue = m.value);
      barData.map((m: any) => m.extraY = 0);
    } else {
      let barVars: any = new Set();
      let stackVars: any = new Set()
      myChart.SmallBarChartData.forEach((d: any) => {
        barVars.add(d[myChart.props.barVar]);
        stackVars.add(d[myChart.props.stackVar]);
      })
      let stackData: any = [];
      Array.from(barVars).forEach((d: any) => {
        const myData: any = { name: d }
        Array.from(stackVars).forEach((v: any) => {
          const myValue = d3.sum(myChart.SmallBarChartData, (s: any) =>
            s[myChart.props.barVar] === d && s[myChart.props.stackVar] === v
              ? s[myChart.props.yVar] : 0);
          myData[v] = myValue;
        })
        stackData.push(myData);
      })
      stackData = d3.stack()
        .keys(Array.from(stackVars))
        .order(d3.stackOrderNone)
       .offset(this.isPercentStacked ? d3.stackOffsetExpand : d3.stackOffsetNone)
        (stackData);

      yMax = d3.max(stackData, (d: any) => d3.max(d, (m: any) => m[1]));
      if(myChart.props.showPercent ||myChart.props.barText){
        yMax *= 1.10;
      }
      const domain = this.isPercentStacked ? [0, 1] : [0, yMax];
      yScale = d3.scaleLinear().domain(domain).range([height - margins.top - margins.bottom, 0]);
      yScaleHeight = d3.scaleLinear().domain(domain).range([0, height - margins.top - margins.bottom]);
      const extraYs: any = {};
      stackData.forEach((d: any, i: any) => {
        const myKey = d.key;
        const isLast = (i === (stackData.length - 1));
        d.map((m: any) => m.value = (m[1] - m[0]))
        d.map((m: any) => m.height = yScaleHeight(m.value));
        d.forEach((s: any, index: any) => {
          let myExtraY = 0;
          if (s.height < 2 && s.value > 0) {
            myExtraY = (2 - s.height);
            s.height = 2;
            extraYs[index] = (extraYs[index] === undefined ? myExtraY : extraYs[index] + myExtraY)
          }
          let myFill = myChart.props.barFill[myKey];
          if (myFill === undefined) {
            myFill = myChart.props.stackColors[i];
            myChart.props.barFill[myKey] = myFill;
            myChart.props.barLabels[myKey] = myKey;
          }
          let total:any =( Object.values(s.data)
          .filter((value:any) => typeof value === 'number')
          .reduce((sum:any, num:any) => sum + num, 0))
          barData.push({
            name:  myChart.props.XaxisDate? new Date(s.data.name): s.data.name,
            data:s.data,
            start: s[0],
            value: s.value,
            height: s.height,
            fill: myFill,
            extraY: extraYs[index] === undefined ? 0 : -extraYs[index],
            totalValue: s[1],
            align:myChart.props.textAlign,
            borderRadius: isLast ? 2 : 0,
            groupIndex: index,
            percentbarvalue:s.data[myKey] || 0,
             percentbarvaluetotal:total,
            percentage: ((myChart.isPercentStacked ? s.data[myKey] : s.value) /total) * 100,
            stackIndex: i,
            stackDatalength: stackData.length,
            errorType: myKey
          })
        })
      })
    }

    const emptyLastBars = barData.filter((f: any) => f.borderRadius > 0 && f.value === 0);
    emptyLastBars.forEach((d: any) => {
      d.borderRadius = 0;
      let filledBars = barData.filter((f: any) => f.groupIndex === d.groupIndex && f.value > 0);
      filledBars = filledBars.sort((a: any, b: any) => d3.descending(a.stackIndex, b.stackIndex));
      if (filledBars.length > 0) {
        filledBars[0].borderRadius = 2;
      }
    })
    const xTicks: any = [];
    barData.forEach((d: any) => {
  if (!xTicks.includes(d.name)) {
    xTicks.push(d.name);
  }
});


     // define clip rect dimensions
     mySvg.select('#brushClipRect' + myClass)
     .style('width', width - margins.left - margins.right)
     .style('height', chartHeight + 20 )
     .attr('transform', 'translate(' + margins.left + ','+ (margins.top -20) +')');

    const xScale: any = d3.scaleBand().domain(xTicks).range([0, width - margins.left - margins.right]);

    mySvg.select('.xAxis' + myClass)
      // @ts-ignore
      .call(d3.axisBottom(xScale).tickSizeOuter(0).tickValues(xTicks))
      .attr('transform', 'translate(' + margins.left + ',' + (height - margins.bottom) + ')');

    mySvg.select('.yAxis' + myClass)
      // @ts-ignore
      .call(d3.axisLeft(yScale).tickSizeOuter(0).ticks(5).tickFormat((d: any) => this.isPercentStacked ? d3.format(".0%")(d) : d === 0 ? '': ((yMax>10) ?d3.format(myChart.props.yAxisFormatting)(d):d3.format(".1~f")(d))))
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');

    mySvg.selectAll('.xAxis' + myClass + ' text')
      .attr('dy', 4)
      .attr('id', (d: any) => 'xLabel_' + d)
      .style('font-weight', 500)
      .style('font-family', "Poppins")
      .style('fill', "#101D42")
      .style('cursor', 'pointer')
      .style('font-size', 10)
      // .style('font-size',this.props.XaxisDate ?  10 : 10)
      .text((d: any) =>  this.props.XaxisDate ? (xTickFormat)(new Date(d)) :(myChart.isFullscreen? d: getXLabel(d.replace(/_/g, ' '), xScale.bandwidth())))
      // .text((d: any) => d)
      // .call(wraps, xScale.bandwidth() );
      .on("mouseover", (event: any, d: any) => {
        if(myChart.isFullscreen)return
       const labelId = `#xLabel_${d}`;
        mySvg.select(labelId).style('fill', 'blue');
    
        if (getXLabel(d.replace(/_/g, ' '), xScale.bandwidth()).includes("..")) {
          myChart.showTooltip('groupFullName', d.replace(/_/g, ' '), event.offsetX, event.offsetY, width, height);
        }
      })
      .on("mouseout", (event: any, d: any) => {
         const labelId = `#xLabel_${d}`;
        mySvg.select(labelId).style('fill', '#101D42');
        myChart.hideTooltip("groupFullName");
      }).on("click", function (event: any, d: any) {
        if(myChart.item?.config?.['intractive_filter']?.value=='true'){
        const labelId = `#xLabel_${d}`;
        mySvg.select(labelId).style('fill', 'blue');
        const fv:any = {'key':myChart.item?.config?.['x_axis_intractive']?.value=='true','value':d}
        myChart.filterService.intractiveFilter.next(fv)
      }
      });
      if (myChart.props.XaxisDate) {
        mySvg.selectAll('.xAxis' + myClass + ' text').call(wrap,20)}
        if (myChart.isFullscreen) {
        mySvg.selectAll('.xAxis' + myClass + ' text').call(wraps,xScale.bandwidth())}

    mySvg.selectAll('.yAxis' + myClass + ' text')
      .style('font-weight', 500)
      .style('font-family', "Poppins")
      .style('fill', "#8A98AB")
      .style('font-size', 10)

    mySvg.selectAll('.yAxis' + myClass + ' line')
      .attr('x1', 0)
      .attr('x2', width - margins.left - margins.right)
      .style('stroke', "#E8EAEE")
      .style('stroke-width', 1);

    mySvg.selectAll('.yAxis' + myClass + ' path')
      .style('display', "none")

    mySvg.selectAll('.xAxis' + myClass + ' path')
      .style('display', "none")

    mySvg.selectAll('.xAxis' + myClass + ' line')
      .style('display', "none")
       // axis labels
       mySvg.select('#xAxisLabel' + myClass)
       .attr('visibility',  'visible')
       .attr('x', margins.left + ((width - margins.left - margins.right)/2))
       .attr('y', height-10)
       .attr('text-anchor', 'middle')
       .attr('font-family', 'Poppins')
       .attr('fill', '#737D88')
       .attr('font-size', '12px')
       // @ts-ignore
       .text(myChart.props.xAxisLabel);

       mySvg.select('#yAxisLabel' + myClass)
       .attr('visibility',  'visible')
       .attr('transform','translate(10,' + ( ((height - margins.top - margins.bottom)/2)) + ') rotate(-90)')
       .attr('text-anchor', 'middle')
       .attr('font-family', 'Poppins')
       .attr('fill', '#737D88')
       .attr('font-size', '12px')
       // @ts-ignore
       .text(myChart.props.yAxisLabel);
     
// const brushX = d3.brushX()
//   .extent([[0, 0], [width - margins.left - margins.right, height - margins.top - margins.bottom]])
//   .on('end', (event: any) => {
//     if (!event.selection) return;

//     const [x0, x1] = event.selection;

//     const selectedTicks = xTicks.filter((tick: string) => {
//       const start = xScale(tick);
//       const end = start + xScale.bandwidth();
//       return start >= x0 && end <= x1;
//     });
//  console.log('Selected Ticks:', selectedTicks);
//     this.showPopup = true; // optional popup
//   });

//     mySvg.append("g")
//   .attr("class", "brush-x")
//   .attr("transform", `translate(${margins.left}, ${chartHeight+ margins.top})`)
//   .attr("height", 54)
//   .call(brushX);

if(myChart.item?.config?.['drag_intractive_filter']?.value=='true'){
 // Drag area rectangle
     mySvg.append('rect')
      .attr('width', 45)
      .attr('x', 0)
      .attr('y', margins.top)
      .attr('height', height - margins.top - margins.bottom)
      .style('fill', '#1363DF')
      .style('fill-opacity', 0.1)
      .style('cursor', 'crosshair')
      .call(
        d3.drag()
          .on('start', (event: any) => {
            this.dragStartY = event.y;
            if (this.selectionBox) this.selectionBox.remove();

            this.selectionBox = mySvg.append('rect')
              .attr('x', 0)
              .attr('width',45)
              .attr('y', event.y)
              .attr('height', 0)
              .style('fill', '#1363DF')
              .style('fill-opacity', 0.1)
              .style('stroke', '#1363DF')
              .style('stroke-width', 1)
              .style('stroke-dasharray', '4,4');
          })
          .on('drag', (event: any) => {
            const height = Math.abs(event.y - this.dragStartY);
            const y = Math.min(event.y, this.dragStartY);
            this.selectionBox.attr('y', y).attr('height', height);
          })
          .on('end', (event: any) => {
            const rawY = event.y;

            // Clamp selection to stay within chart bounds
            const clampedY = Math.max(margins.top, Math.min(rawY, height - margins.bottom));
            const clampedStartY = Math.max(margins.top, Math.min(this.dragStartY, height - margins.bottom));

            const yStartPx = Math.min(clampedStartY, clampedY);
            const yEndPx = Math.max(clampedStartY, clampedY);
            const selectionHeight = yEndPx - yStartPx;

            // Convert pixel positions (relative to chart area) to data values
            const chartYStart = yStartPx - margins.top;
            const chartYEnd = yEndPx - margins.top;

            const valueMax = yScale.invert(chartYStart); // top = max
            const valueMin = yScale.invert(chartYEnd);   // bottom = min

            this.selectedRange = { min: valueMin, max: valueMax };
            this.showPopup = true;

            // Clear previous selection visuals
            mySvg.selectAll('.selection-line, .selection-label, .selection-bg').remove();

            // Draw selection rectangle
            mySvg.append('rect')
              .attr('class', 'selection-bg')
              .attr('x', margins.left)
              .attr('y', yStartPx)
              .attr('width', width - margins.left - margins.right)
              .attr('height', selectionHeight)
              .style('fill', '#8A98AB')
              .style('fill-opacity', 0.1);

            ['top', 'bottom'].forEach((pos, index) => {
              const yPos = index === 0 ? yStartPx : yEndPx;
              const dataVal = index === 0 ? valueMax : valueMin;

              mySvg.append('line')
                .attr('class', `selection-line selection-line-${pos}`)
                .attr('x1', margins.left)
                .attr('x2', width - margins.right)
                .attr('y1', yPos)
                .attr('y2', yPos)
                .attr('stroke', '#8A98AB')
                .attr('stroke-width', 1);

              const cardWidth = 60;
              const cardHeight = 24;

              // Background card
              mySvg.append('rect')
                .attr('class', `selection-label selection-label-bg selection-card-${pos}`)
                .attr('x', width - cardWidth - 10)
                .attr('y', yPos - cardHeight / 2)
                .attr('width', cardWidth)
                .attr('height', cardHeight)
                .attr('rx', 4)
                .attr('fill', '#fff')
                .attr('stroke', '#8A98AB')
                .attr('stroke-width', 1);

              // Text label
              mySvg.append('text')
                .attr('class', `selection-label selection-label-text selection-card-text-${pos}`)
                .attr('x', width - cardWidth / 2 - 10)
                .attr('y', yPos + 4)
                .text(`${dataVal.toFixed(2)}`)
                .attr('fill', '#101D42')
                .attr('text-anchor', 'middle')
                .attr('font-size', 12);
            });
          })
      );
mySvg.append('rect')
  .attr('height', 45)
  .attr('y', height - 45) // drag area near bottom
  .attr('x', margins.left)
  .attr('width', width - margins.left - margins.right)
  .style('fill', '#1363DF')
  .style('fill-opacity', 0.1)
  .style('cursor', 'crosshair')
  .call(
    d3.drag()
      .on('start', (event: any) => {
        this.dragStartX = event.x;
        if (this.selectionBoxX) this.selectionBoxX.remove();

        this.selectionBoxX = mySvg.append('rect')
          .attr('y', height - 45)
          .attr('height', 45)
          .attr('x', event.x)
          .attr('width', 0)
          .style('fill', '#1363DF')
          .style('fill-opacity', 0.1)
          .style('stroke', '#1363DF')
          .style('stroke-width', 1)
          .style('stroke-dasharray', '4,4');
      })
      .on('end', (event: any) => {
  const rawX = event.x;
  const clampedX = Math.max(margins.left, Math.min(rawX, width - margins.right));
  const clampedStartX = Math.max(margins.left, Math.min(this.dragStartX, width - margins.right));

  const xStartPx = Math.min(clampedStartX, clampedX);
  const xEndPx = Math.max(clampedStartX, clampedX);
  const selectionWidth = xEndPx - xStartPx;

  const chartXStart = xStartPx - margins.left;
  const chartXEnd = xEndPx - margins.left;

  // Get list of selected categories (xTicks are domain values)
  const selectedCategories = xTicks.filter((tick:any) => {
    const bandStart = xScale(tick);
    const bandEnd = bandStart + xScale.bandwidth();
    return bandEnd >= chartXStart && bandStart <= chartXEnd;
  });
console.log('Selected Categories:', selectedCategories);
  // this.selectedXCategories = selectedCategories;
  this.showPopup = true;

  mySvg.selectAll('.selection-line-x, .selection-label-x, .selection-bg-x').remove();

  // Draw background rectangle for visual feedback
  mySvg.append('rect')
    .attr('class', 'selection-bg-x')
    .attr('x', xStartPx)
    .attr('y', margins.top)
    .attr('width', selectionWidth)
    .attr('height', height - margins.top - margins.bottom)
    .style('fill', '#8A98AB')
    .style('fill-opacity', 0.1);

  // Label left and right with category names
  const labelData = [
    { pos: xStartPx, label: selectedCategories[0] },
    { pos: xEndPx, label: selectedCategories[selectedCategories.length - 1] }
  ];

  labelData.forEach(({ pos, label }) => {
    const cardWidth = 80;
    const cardHeight = 24;

    mySvg.append('rect')
      .attr('class', `selection-label-x`)
      .attr('x', pos - cardWidth / 2)
      .attr('y', margins.top - cardHeight - 5)
      .attr('width', cardWidth)
      .attr('height', cardHeight)
      .attr('rx', 4)
      .attr('fill', '#fff')
      .attr('stroke', '#8A98AB')
      .attr('stroke-width', 1);

    mySvg.append('text')
      .attr('class', `selection-label-x`)
      .attr('x', pos)
      .attr('y', margins.top - cardHeight / 2 - 5 + 6)
      .text(label)
      .attr('fill', '#101D42')
      .attr('text-anchor', 'middle')
      .attr('font-size', 12);
  });
})
      );
    }


    if (myChart.props.stackVar !== null || myChart.props.showLegend) {
      drawLegend(Object.keys(myChart.props.barFill));
    }
//     mySvg.select('#chartGroup' + myClass).remove(); 
//     const barGroup = mySvg.append('g')
//     .attr('id', 'chartGroup' + myClass)
//     .selectAll('.chartGroup' + myClass)
//       .data(barData)
//       .join((group: any) => {
//         const enter = group.append('g').attr('class', 'chartGroup' + myClass);
//         enter.append('path').attr('class', 'barRect');
//         enter.append('text').attr('class', 'barValue');
//         return enter;
//       });

//     const barWidth = xScale.bandwidth() / 4;
// if (myChart.props.barText) {
     
//     barGroup.select('.barValue')
//     .attr('fill',(d: any) => d.fill )
//     // .attr('x',barWidth/4)
//     .style("font-size", barWidth)
//     .style("font-family", "Poppins")
//     .style("font-weight", 500)
//     .text((d:any)=> d.totalValue)
//     .attr('transform',(d: any) => 'translate(' + (margins.left + xScale(d.name) + (xScale.bandwidth() * 0.375))
//     + ',' + (margins.top + (yScale(d.totalValue) + d.extraY-5)) + ')');
//   }

//     barGroup.select('.barRect')
//       .attr('d', (d: any) => 'M0,' + d.height + 'L0,' + d.borderRadius
//         + ' Q0,0 ' + d.borderRadius + ',0 L' + (barWidth - d.borderRadius)
//         + ',0 Q' + barWidth + ',0 ' + barWidth + ',' + d.borderRadius
//         + ' L' + barWidth + ',' + d.height + 'Z')
//       .attr('fill', (d: any) => d.fill)
//       .attr('stroke-width', 0)
//       .attr('transform', (d: any) => 'translate(' + (margins.left + xScale(d.name) + (xScale.bandwidth() * 0.375))
//         + ',' + (margins.top + (yScale(d.totalValue) + d.extraY)) + ')')
//       .on("mouseover", (event: any, d: any) => {
//         let tooltipData = "";
//         if (myChart.props.stackVar === null) {
//           tooltipData = d;
//         } else {
//           tooltipData = barData.filter((f: any) => f.name === d.name);
//         }
//         myChart.showTooltip('bar', tooltipData, event.offsetX, event.offsetY, width, height);
//       })
//       .on("mouseout", () => {
//         myChart.hideTooltip('bar');
//       });
 // draw chart
 const barGroup = mySvg.select('#chartGroup' + myClass)
   .selectAll('.chartGroup' + myClass)
   .data(barData)
   .join((group: any) => {
     const enter = group.append('g').attr('class', 'chartGroup' + myClass);
     enter.append('path').attr('class', 'barRect');
     enter.append('text').attr('class', 'barValue');
     enter.append('text').attr('class', 'barPerecentValue');

     return enter;
   });
     barGroup.attr('clip-path', (d: any) =>  'url(#brushClip' + myClass + ')');
 drawChart();
 function drawChart(){
	  let yDomainMin = myChart.lineMin || 0;
    let yDomainMax = myChart.lineMax || Number(yMax);
    const domain = myChart.isPercentStacked ? [0, 1.1] : [yDomainMin, yDomainMax];

    yScale = d3.scaleLinear().domain(domain).range([height - margins.top - margins.bottom, 0])
    yScaleHeight = d3.scaleLinear().domain(domain).range([0, height - margins.top - margins.bottom])

    mySvg.select('.yAxis' + myClass).call(d3.axisLeft(yScale).tickSizeOuter(0).ticks(5).tickFormat((d: any) => myChart.isPercentStacked ? d3.format(".0%")(d) : d === 0 ? '':((yMax>10) ?(d+ (myChart.props.surfix ||'')):d3.format(".1~f")(d)))).attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');
    mySvg.select('.yAxis' + myClass)
    .call((g:any) =>
      g.selectAll(".tick line")
      .attr("x2", width - margins.left - margins.right)
      .attr("stroke-dasharray", "2,2")
      .attr("stroke", "#ccc"))
      .call((g:any) =>
      g.selectAll("path")
      .attr("display", 'none')
      );
       mySvg.selectAll('.yAxis' + myClass + ' text')
      .style('font-weight', 400)
      .style('font-family', "Poppins")
      .style('fill', "#101D42")
      .style('font-size', 10)

    mySvg.selectAll('.yAxis' + myClass + ' line')
      .attr('x1', 0)
      .attr('x2', width - margins.left - margins.right)
      .style('stroke', "#ccc")
      .style('stroke-width', 1);

    mySvg.selectAll('.yAxis' + myClass + ' path')
      .style('display', "none")
 
 const barWidth = xScale.bandwidth() / 2;
if (myChart.props.barText) {

 barGroup.select('.barValue')
 .attr('fill',(d: any) => '#828ca2' )
 .attr('x',barWidth/2)
 .attr('text-anchor', 'middle')
 .style("font-size", (barWidth/3)>12?12:(barWidth/3))
 .style("font-family", "Poppins")
 .style("font-weight", 500)
 .text((d:any)=>  (d.stackDatalength-1 == d.stackIndex) ? (myChart.isPercentStacked ? d.percentbarvaluetotal:(d.totalValue + (myChart.props.surfix ||''))) : d.totalValue)
 .attr('transform',(d: any) => 'translate(' + (margins.left + xScale(d.name) + (xScale.bandwidth() * 0.250))
 + ',' + (margins.top + (yScale(d.totalValue) + d.extraY-5)) + ')');
}
if (myChart.props.showPercent) {
  const percentText = barGroup.select('.barPerecentValue')
    .attr('fill',(d: any) => (d.align=='right'||d.align=='left') ? d.fill: '#fff')
    .style("font-size", (barWidth/4)>12?12:(barWidth/4))
    .style("font-family", "Poppins")
    .style("font-weight", 500)
    .text((d: any) => ((barWidth/2) <= (yScale(0) - yScale(d.value))) ? (myChart.formatPercentage(d.percentage)) : undefined)
    .attr('transform', (d: any) => {
      const xBase = margins.left + xScale(d.name) + (xScale.bandwidth() * 0.500);
      const barHeight = yScale(0) - yScale(d.value);
      const yBase = margins.top + yScale(d.totalValue);
      switch (d.align) {
        case 'top':
          return `translate(${xBase}, ${yBase + 20})`;
        case 'bottom':
          return `translate(${xBase}, ${yBase + barHeight -20})`;
        case 'left':
          return `translate(${xBase - (barWidth / 2 )}, ${yBase + barHeight / 2})`;
        case 'right':
          return `translate(${xBase + (barWidth / 2)}, ${yBase + barHeight / 2})`;
        case 'center':
          return `translate(${xBase}, ${yBase + barHeight / 2})`;
        default:
          return `translate(${xBase}, ${yBase + 20})`;
      }
    })
    .attr('text-anchor', (d: any) => {
      switch (d.align) {
        case 'left':
          return 'end';
        case 'right':
          return 'start';
        case 'center':
          return 'middle';
        default:
          return 'middle';
      }
    })
    .attr('dominant-baseline', (d: any) => {
      switch (d.align) {
        case 'top':
          return 'auto';
        case 'bottom':
          return 'hanging';
        case 'center':
          return 'middle';
        default:
          return 'auto';
      }
    });

  // ✅ Raise *after all attribute setting*
  percentText.raise();
}



 barGroup.select('.barRect')
   .attr('d', (d: any) =>{ 
    let barHeight = yScale(0) - yScale(d.value)
    barHeight = barHeight < 3 && barHeight !== 0 ? 3 : barHeight;
     return 'M0,' +( barHeight) + 'L0,' + d.borderRadius
     + ' Q0,0 ' + d.borderRadius + ',0 L' + (barWidth - d.borderRadius)
     + ',0 Q' + barWidth + ',0 ' + barWidth + ',' + d.borderRadius
     + ' L' + barWidth + ',' + ( barHeight) + 'Z'})
   .attr('fill', (d: any) => d.fill)
   .attr('stroke-width', 0)
   .attr('transform', (d: any) => 'translate(' + (margins.left + xScale(d.name) + (xScale.bandwidth() * 0.250))
     + ',' + (margins.top + (yScale(d.totalValue) + d.extraY)) + ')')
   .on("mousemove", (event: any, d: any) => {
     let tooltipData:any;
     if (myChart.props.stackVar === null) {
       tooltipData = d;
     } else {
       tooltipData = barData.filter((f: any) => f.name === d.name);
        tooltipData = tooltipData.sort((a: any,b: any) =>  a.errorType == d.errorType ? -1 : b.errorType == d.errorType ? 1 : 0);
     }
     myChart.showTooltip('bar', tooltipData, event.offsetX, event.offsetY, width, height);
   })
   .on("mouseout", () => {
     myChart.hideTooltip('bar');
   }).on("click", function (event: any, d: any) {
     if(myChart.item?.config?.['intractive_filter']?.value=='true'){
        // alert('Clicked label:'+ d.errorType);
        myChart.filterService.dummyVal= d.errorType
      const fv:any = {'key':myChart.item?.config?.['bar_intractive']?.value,'value':(d.errorType)}
      myChart.filterService.intractiveFilter.next(fv)
              
        // alert('Clicked label: ' + d);
     }
      });
  }
    
 const slider = mySvg.select('#sliderGroup' + myClass);

    // // Bar Slider
    // myChart.barMin = myChart.currentMin;
    // myChart.barMax = sbarMax;
    // createRangeSlider('bar', myChart.currentMin, sbarMax);
    
    // Line Slider 
    if(myChart.props.slider){
    myChart.lineMin = myChart.currentMin;
    myChart.lineMax = yMax;
    createRangeSlider('bar', myChart.currentMin, yMax);
    }
    


        function createRangeSlider(id: string, min: number, max: number): void {
           const sliderGroupId = `sliderGroup-${id}`;
           const sliderClass = `${id}-slider`;
         
           // Remove any existing slider group for this ID
           slider.select(`#${sliderGroupId}`).remove();
         
           // Create a new slider group
           const sliderGroup = slider.append('g').attr('id', sliderGroupId);
           // Scale setup for the slider
           const scale = d3.scaleLinear()
             .domain([min, max])
             .range(myChart.orientation === 'horizontal' ? [0, yScale.range()[0]] : [yScale.range()[0], 0])
             .clamp(true);
         
           // Drag event handlers for the min and max handles
           const dragMinHandle = d3.drag().on('drag', (event) => onDragMinHandle( sliderGroup,event, scale, sliderClass, id, min, max));
           const dragMaxHandle = d3.drag().on('drag', (event) => onDragMaxHandle( sliderGroup,event, scale, sliderClass, id, min, max));
         
           // Create the slider track and inset line
           sliderGroup.append('line')
             .attr('class', `${sliderClass} ${id}-track`)
             .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
             .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max))
             .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
             .attr('stroke', '#ddd')
             .attr('stroke-width', 1);
         
           sliderGroup.append('line')
             .attr('class', `${sliderClass} ${id}-track-inset`)
             .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
             .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max + margins.top))
             .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
             .attr('stroke', '#ddd')
             .attr('stroke-width', 1);
         
           // Tooltip setup
           const tooltip = d3.select('body').append('div')
             .attr('class', 'tooltip')
             .style('position', 'absolute')
             .style('padding', '5px')
             .style('background', '#fff')
             .style('border', '1px solid #ccc')
             .style('border-radius', '4px')
             .style('pointer-events', 'none')
             .style('opacity', 0);
         
           // Create Min and Max handles with hover and drag functionality
           createSliderHandle( sliderGroup,sliderClass, id, 'min', min, scale, dragMinHandle, tooltip);
           createSliderHandle(sliderGroup,sliderClass, id, 'max', max, scale, dragMaxHandle, tooltip);
         }
   
         function createSliderHandle(sliderGroup:any,sliderClass: string, id: string, handleType: string, value: number, scale: any, dragHandle: any, tooltip: any): void {
           const circleColor:string = handleType === 'min'? '#718EB6': '#69b3a2';
           
           // Hover effect layer
           const hoverLayer = sliderGroup.append('circle')
             .attr('class', `${sliderClass} ${id}-${handleType}-hover-layer`)
             .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
             .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
             .attr('r', myChart.handleRadius + 8)
             .attr('fill', circleColor)
             .attr('opacity', 0)
             .attr('pointer-events', 'none');
             
           // Create handle
           const handle = sliderGroup.append('circle')
              .attr('class', `${sliderClass} ${id}-${handleType}-handle`)
              .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
              .attr('transform', `translate(${id === 'line' ? (width - margins.left + 40) : (margins.left )}, ${margins.top})`)
              .attr('r', myChart.handleRadius)
              .attr('fill', circleColor)
              // Put clicked handle to bottom of DOM group so that it overlaps the other handle
              .on('mousedown', function(){
                handle.raise();
              })
              .call(dragHandle);
         
           // Handle hover effect
           handle.on('mouseover', function(event: any) {
             hoverLayer.transition().duration(200).attr('opacity', 0.4);  // Show hover layer
             // sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
             //         .attr('stroke-width', 4)
             //         .attr('stroke', '#69b3a2');  // Change color on hover
               //  tooltip
               // .style('opacity', 1)
               // .html(`Max: ${id === 'bar' ? myChart.barMax : myChart.lineMax}`)
               // .style('left', `${event.pageX + 10}px`)
               // .style('top', `${event.pageY - 20}px`);
           })
           .on('mouseout', function() {
             hoverLayer.transition().duration(400).attr('opacity', 0);  // Hide hover layer
             // sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
             //         .attr('stroke-width', 1)
             //         .attr('stroke', '#ddd');  // Revert to original color
                     // tooltip.style('opacity', 0);  // Hide tooltip on mouse out
           })
           .on('mousemove', function(event: any) {
             // Update tooltip position
             //  tooltip
             //   .style('opacity', 1)
             //   .html(`Max: ${id === 'bar' ? myChart.barMax : myChart.lineMax}`)
             //   .style('left', `${event.pageX + 10}px`)
             //   .style('top', `${event.pageY - 20}px`);
             // tooltip.style('left', `${event.pageX + 10}px`).style('top', `${event.pageY - 20}px`);
           });
         }
         
         function onDragMinHandle(sliderGroup:any,event: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
          const newPos = Math.max(scale(max), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - margins.top);
          const currentMin = Math.round(scale.invert(newPos) - 1);
          // If our drag is greater than the minimum edge and less than the Max handle
          if (currentMin >= min && currentMin <= (id === 'line' ? myChart.barMax - 5 : myChart.lineMax - 5)) {
            id === 'line'? myChart.barMin = currentMin : myChart.lineMin = currentMin;
            // update the chart minimum and set the handle to the new position
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'min', newPos);
            updateTrackInset(sliderGroup,scale, sliderClass, id, currentMin, max);
            drawChart();
          }
          // Our drag is less than the minimum edge of the axis
          else if (currentMin < min){
            id === 'line'? myChart.barMin = min : myChart.lineMin = min;
            // Set the handle position to the minimum edge of the axis
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'min', scale(min));
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, max);
            drawChart();
          }
         }
         
         function onDragMaxHandle(sliderGroup:any,event: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
          const newPos = Math.min(scale(min), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - margins.top);
          const currentMax = Math.round(scale.invert(newPos) + 1);
          // If our drag is less than the maximum edge and more than the Min handle
          if (currentMax <= max && currentMax >= (id === 'line' ? myChart.barMin + 5 : myChart.lineMin + 5)) {
            id === 'line'? myChart.barMax = currentMax : myChart.lineMax = currentMax;
            // update the chart maximum and set the handle to the new position
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'max', newPos);
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, currentMax);
            drawChart();
          }
          // Our drag is more than the maximum edge of the axis
          else if (currentMax > max){
            id === 'line'? myChart.barMax = max : myChart.lineMax = max;
            // Set the handle position to the maximum edge of the axis
            updateSliderHandlePosition(sliderGroup,sliderClass, id, 'max', scale(max));
            updateTrackInset(sliderGroup,scale, sliderClass, id, min, max);
            drawChart();
          }
         }
         function updateTrackInset(sliderGroup:any,scale: any, sliderClass: string, id: string, min: number, max: number): void {
           sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
             .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
             .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max));
         }
         
         function updateSliderHandlePosition( sliderGroup:any,sliderClass: string, id: string, handleType: string, newPos: number): void {
           sliderGroup.select(`.${sliderClass}.${id}-${handleType}-handle`)
             .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
             sliderGroup.select(`.${sliderClass}.${id}-${handleType}-hover-layer`)
             .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
         }



function drawLegend(legendData: any) {
  console.log('legendbar', legendData, myChart.props.barFill);

  const legendGroup = mySvg
    .select('#legendGroup' + myClass)
    .selectAll('.legendItem' + myClass)
    .data(legendData, (d: any) => d)
    .join(
      (enter: any) => {
        const g = enter.append('g')
          .attr('class', 'legendItem' + myClass);
        g.append('circle').attr('class', 'legendCircle');
        g.append('text').attr('class', 'legendLabel');
        return g;
      },
      (update: any) => update,
      (exit: any) => exit.remove()
    );

  // ✅ Circle setup
  legendGroup.select('.legendCircle')
    .attr('id', (d: any) => `circle_legendItem_${String(d).replace(/[^a-zA-Z0-9]/g, '')}`)
    .attr('fill', (d: any) => myChart.props.barFill[d] || '#101D42')
    .attr('r', 4);

  // ✅ Text setup
  legendGroup.select('.legendLabel')
    .attr('id', (d: any) => `legendItem_${String(d).replace(/[^a-zA-Z0-9]/g, '')}`)
    .attr('y', 5)
    .attr('fill', '#101D42')
    .attr('font-weight', '500')
    .attr('font-size', '12')
    .attr('font-family', 'Poppins')
    .text((d: any) => (myChart.props.barLabels?.[d] || d).toUpperCase());

  // ✅ Positioning
  let legendX = 0;
  legendGroup.each(function (d: any) {
    //@ts-ignore
    const textEl: any = d3.select(this).select('.legendLabel').node();
    const textWidth = textEl?.getBBox()?.width || 0;
    //@ts-ignore
    d3.select(this).select('.legendCircle')
      .attr('cx', legendX)
      .attr('cy', 0);

    //@ts-ignore
    d3.select(this).select('.legendLabel')
      .attr('x', legendX + 10);

    legendX += textWidth + 30; // spacing
  });

  // ✅ Center align the entire legend group
  const offsetX = (width - legendX) / 2;
  mySvg.select('#legendGroup' + myClass)
    .attr('transform', `translate(${offsetX}, 20)`);
}


    function getXLabel(myLabel: any, bandwidth: any) {
      while (!checkWidth(myLabel) || myLabel === "..") {
        if (myLabel.includes("..")) {
          myLabel = myLabel.substr(0, myLabel.length - 2);
        }
        myLabel = myLabel.substr(0, myLabel.length - 1) + "..";
      }
      return myLabel;
      function checkWidth(myText: any) {
        if ((measureWidth(myText, 12) + 4) > bandwidth) {
          return false
        } else {
          return true
        }
      }
    }

    function measureWidth(myText: any, myFontSize: any): any {
      const context: any = document.createElement('canvas').getContext('2d');
      context.font = myFontSize + 'px sans-serif';
      return context.measureText(myText).width;
    }

    function wrap(text: any, width: any): void {
      text.selectAll('tspan').remove();

      text.each(function (): any {
        let lineNumber = 0;
        //@ts-ignore
        const text = d3.select(this);
        const words = text.text().split(/\s+/).reverse();
        let word = null;
        let line: any = [];
        const lineHeight = 12;
        const dy = 15;
        let tspan: any = text.text(null).append('tspan').attr('x', 0).attr('y', 0).attr('dy', dy + 'px');
        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(' '));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            if (line.length > 0) {
              tspan.text(line.join(' '));
              line = [word];
              if (word.trim().length > 0) {
                lineNumber += 1;
                tspan = text.append('tspan').attr('x', 0).attr('y', 0).attr('dy', lineNumber * lineHeight + dy + 'px').text(word);

              }
            } else {
              line = [word]
            }
          }
        }
      });
    }
     function wraps(text: any, width: any): void {
               text.selectAll('tspan').remove();
    
               text.each(function(): any {
                 let lineNumber = 0;
                 //@ts-ignore
                 const text = d3.select(this);
                 const words = text.text().split(/\s+/).reverse();
                 let word = null;
                 let line: any = [];
                 const lineHeight = 11;
                 const dy = 22;
                 let tspan: any = text.text(null).append('tspan').attr('x', 0).attr('y', -9).attr('dy', dy + 'px');
                 while (word = words.pop()) {
                   line.push(word);
                   tspan.text(line.join(' '));
                   if (tspan.node().getComputedTextLength() > width) {
                     line.pop();
                     if(line.length > 0){
                       tspan.text(line.join(' '));
                       line = [word];
                       if (word.trim().length > 0){
                         lineNumber += 1;
                         tspan = text.append('tspan').attr('x', 0).attr('y', -9).attr('dy', lineNumber * lineHeight + dy + 'px').text(word);
    
                       }
                     } else {
                       line = [word]
                     }
                   }
                 }
               });
             }
    this.stop(10).then(() => this.isLoading = false);
  }
  // property & data for the chart
  getSmallBarChartData() {
    this.SmallBarChartData = this.data
// debugger
let cgf:any = this.item?.config
    this.isPercentStacked = this.item.config?.["percent_bar"]?.value === 'true' ? true : false;
    const barFill:any = {};
    const barLabels:any = {};
    
    // Populate the objects dynamically
    cgf?.bar_Fill?.values?.forEach((item:any) => {
        barFill[item.col_value] = item.color;  // Assign the color to barFill
        barLabels[item.col_value] = item?.col_label ? item.col_label :  item.col_value;  // Assign the col_value as the label
    });
     this.props = {
        chartHeight: 500,
        barVar:cgf?.x_axis?.['api_resp_column_nm']|| 'data_source_name',
        yVar: cgf?.y_axis?.['api_resp_column_nm']||'rec_count',//||'defect_count',
        stackVar: cgf?.stacked_var?.['api_resp_column_nm']||'type',//'error_type', //single bar if stackVar === null
        barFill:barFill|| { 'Government': '#FFD953', 'Commercial':'#751ea5'  ,'Medicaid':'#FF842B', 'CASH':"#CB04DC"}, //'W': "deeppink","FP" : "skyblue",
        barLabels: barLabels||{ 'Government': 'Government','Commercial': 'Commercial',"Medicaid":"Medicaid","CASH":"CASH"  },//'W': "Warnings","FP" : "Failures But Processed"
        showLegend: true,
        XaxisDate:cgf?.['XaxisDate']?.value=='true' ||false,
        stackColors: ["#E74028", "#2CB239", "#25D3EB", "#FFB039", "#1566DE", "#7848FF", "#7AD045", "#CB04DC", "#FA195C", "#9E0000", "#EACD37", "#DD630B", "#BCD03F", "#14BDA9", "#8A05F3", "#D9476A", "#2DADB6", "#E468C2", "#199CD4", "#0934CC",'#1F2B97','#2B6BCB','#2F3CAF','#3E85EF','#404CBB','#4832A1','#49ACA0','#58B3B9','#5EDE6B','#663DBC','#6651BE','#6BCFDD','#7458E7','#7559C5','#81B661','#B04747','#BB3847','#BBAB54','#BFC23D','#C45B0F','#C75FD0','#D0662A','#D25297','#DD6287','#DE7D48','#E29063','#FF5740','#FFC164'],
        barText:cgf?.['show_total_ontop']?.value=='true' ||false,
        showPercent:cgf?.['percentage_on_bar']?.value=='true' ||false,
        textAlign:cgf?.['text_align']?.value|| 'center',
        xAxisLabel:  cgf?.x_axis_label?.toUpperCase()|| ' ',
        yAxisLabel:  cgf?.y_axis_label?.toUpperCase()||   ' ',
        yAxisFormatting: '-2~s',
        period:'M',
        surfix: this.item?.config?.['surfix'] || '%',
        slider:  (cgf?.['zoom_slider_left']?.value=='true'||cgf?.['zoom_slider']?.value=='true') || false,
      }
      if (this.item.config?.list_of_api?.api_key == 100609) {
        this.props = {
          chartHeight: 250,
          barVar: 'period',
          yVar: 'time_to_therapy',
          stackVar: null,
          stackColors: ['deeppink', 'blue', 'gold'],
          barFill: {"time_to_therapy": "#1363DF" },
          barLabels: {'time_to_therapy':"days"},
          showLegend: true,
          XaxisDate:true,
          barText:true,
          period:"M",
          yAxisFormatting: '-2~s',
          slider:  this.item.config?.['zoom_slider_left']?.value=='true' || false,
        }
      }
   
    // @ts-ignore
     if (this.SmallBarChartData.length > 0) {
      this.noData = false
      setTimeout(() => {
        this.plotChart();
      }, 100);
    } else {
      this.noData = true; this.noDataNotifier.report('small-bar-chart')
      this.stop(10).then(() => this.isLoading = false);
    }
  }
  // numberFormat
  numbedPipe(value: any) {
    return this.currency.transform(value, '', '', '1.0-2') + (this.props?.surfix||'') ;
    //  return   this.numberpipe.transform(value)
  }
  // removeUnderScore from the text
  removeUnderScore(value: string) {
    return value.replace(/_/g, ' ').toUpperCase()
  }
  errorType(errorType: any) {
    switch (errorType) {
      case 'E': return "Errors"
      case 'F': return "Failures"
      case 'W': return "Warnings"
      case 'FP': return "Failures But Processed"
      default: return this.removeUnderScore(errorType)


    }

  }
 applySelection(): void {
    console.log('Range applied:', this.selectedRange);
    this.showPopup = false;
    this.cleanupLines();
  }

  cancelSelection(): void {
    this.selectedRange = null;
    this.showPopup = false;
    this.cleanupLines();
  }
cleanupLines(): void {
  d3.selectAll('.selection-line, .selection-label, .selection-bg').remove();
  if (this.selectionBox) {
    this.selectionBox.remove();
    this.selectionBox = null;
  }
}
   formatPercentage(value: number): string {
  if (Math.abs(value) < 0.01) return '0%'; // treat near-zero as 0%
  if (Math.abs(value - 100) < 0.01) return '100%'; // treat near-100 as 100%
  return `${value.toFixed(2)}%`;
}
}
